import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import icoStyledLinkSmall from "src/assets/images/icoStyledLinkSmall.svg";
import { setListData, setListDataInit } from "src/store/reducers/fulfillListReduce";
import { getPathValue } from "src/utils/queryStringUtil";
import styled from "styled-components";
import VideoBox from "../common/VideoBox";

interface DetailDashBoxProps {
  userInfo: any;
  //매장 아이디로는 executeCount가 안들어옴.
  executeCount?: ExcuteCount;
  executeStore: ExcuteList[];
  noticeId: string;
}

const DetailDashBox = (props: DetailDashBoxProps) => {
  const noId: any = getPathValue(); // 이행번호
  const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toListPage = async (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setListDataInit());
    dispatch(
      setListData({
        keywordSearchData: "",
        currentPageNumber: 1,
      }),
    );
    await navigate(`/fulfill-list/` + noId);
  };

  return (
    <DetailDashWrap>
      <p className="title">공지 이행대상</p>
      {props.userInfo.user_type == "E" && props.executeCount && (
        <>
          <Link to={"/dash-detail/" + props.noticeId}>
            <DlBox>
              <div className="title">
                <p>이행현황</p>
                <span>자세히</span>
              </div>
              <ul className="dash-summary">
                <li>
                  <span>전체</span>
                  <p>{props.executeCount.total}</p>
                </li>
                <li>
                  <span>평가완료</span>
                  <p>{props.executeCount.c}</p>
                </li>
                <li>
                  <span>평가 전(재)</span>
                  <p>
                    {props.executeCount.b}
                    <span className="sub-info">({props.executeCount.b_re})</span>
                  </p>
                </li>
                <li>
                  <span>미이행(재)</span>
                  <p>
                    {props.executeCount.n}
                    <span className="sub-info">({props.executeCount.n_re})</span>
                  </p>
                </li>
              </ul>
            </DlBox>
          </Link>
        </>
      )}
      <DlBox>
        <div className="title">
          <a onClick={toListPage}>
            <p>이행목록</p>
            <span>자세히</span>
          </a>
        </div>
        <div className="fulfill-summary">
          {props.executeStore.length > 0 ? (
            <ul>
              {props.executeStore.map((store, index) => (
                <li key={index}>
                  <Link to={"/fulfill-detail/" + store.execute_idx}>
                    {store.img_url.includes("attachment") ? (
                      <img src={imageServerIp + store.img_url} alt="detail" />
                    ) : (
                      <VideoBox controls vimeoId={store.img_url} />
                    )}

                    <p className="shop-name">{store.store_name}</p>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p>아직 이행한 매장이 없습니다.</p>
          )}
        </div>
      </DlBox>
    </DetailDashWrap>
  );
};

const DetailDashWrap = styled.div`
  padding: 30px 0 34px 15px;
  border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
  .title {
    margin-bottom: 32px;
    font-size: 18px;
    font-weight: 700;
  }
`;

const DlBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-start")}
  .title {
    flex-shrink: 0;
    width: 50px;
    margin-right: 35px;
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 12px;
    line-height: 20px;
    p {
      font-weight: 700;
    }
    span {
      display: inline-block;
      padding-right: 12px;
      margin-top: 5px;
      background: url(${icoStyledLinkSmall}) no-repeat right center;
      background-position-y: 3px;
      font-weight: 400;
    }
  }
  .dash-summary {
    flex-grow: 1;
    padding-right: 15px;
    ${({ theme }) => theme.flexBox.flexMixin("row", "space-around", "flex-start")}
    > li {
      width: 33.3%;
      span {
        display: inline-block;
        color: ${({ theme }) => theme.color.tertiary};
        font-size: 12px;
        line-height: 20px;
      }
      p {
        margin-top: 5px;
        font-family: "Poppins";
        font-size: 18px;
      }
      .sub-info {
        font-family: "Poppins";
        font-size: 16px;
        color: ${({ theme }) => theme.color.quaternary};
      }
    }
  }
  .fulfill-summary {
    width: 100%;
    overflow: hidden;
    ul {
      overflow-x: auto;
      overflow-y: hidden;
      ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-start")}
      > li {
        overflow: hidden;
        display: inline-block;
        width: 95px;
        margin-right: 8px;
        flex: 0 0 auto;
        &:last-child {
          margin-right: 15px;
        }
        img {
          overflow: hidden;
          width: 95px;
          height: 95px;
          object-fit: cover;
          vertical-align: top;
        }
        .shop-name {
          margin-top: 5px;
          color: ${({ theme }) => theme.color.tertiary};
          font-size: 12px;
          line-height: 20px;
          ${({ theme }) => theme.textOverflow.singleLine()}
        }
      }
    }
  }
`;

export default DetailDashBox;
